import { gql } from "@apollo/client";

export const GET_SOLICITUD_INDICACION_PENDIENTE = gql`
  query GetSolicitudIndicacionPendiente($idEvaluacion: Int!) {
    solicitudIndicacionPendiente(idEvaluacion: $idEvaluacion) {
      success
      error
      valorEsperado {
        idIndicacionAprobacion
      }
    }
  }
`;